import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=6f512ac5&scoped=true&"
import script from "./CommentInput.vue?vue&type=script&lang=ts&"
export * from "./CommentInput.vue?vue&type=script&lang=ts&"
import style0 from "./CommentInput.vue?vue&type=style&index=0&id=6f512ac5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f512ac5",
  null
  
)

export default component.exports